import { cloneElement, createElement, isValidElement, ReactNode } from 'react';
import { observer } from 'mobx-react';
import { RouterPaths } from '../../router/RouterPaths';
import { Navigate } from 'react-router';
import { useStores } from '../../hooks';

interface FeatureToggleProps {
    name: string;
    strict?: boolean;
    children?: ReactNode;
    fallback?: any;
}

export const FeatureToggle = observer(function FeatureToggleComponent(props: FeatureToggleProps) {
    const { name, strict, children, fallback, ...rest } = props;
    const stores = useStores();

    // Render children until the practices store reports it is loaded; the store may be absent
    // entirely (partially mocked root store), which also means "not ready".
    if (!stores?.domain?.practicesStore?.isLoaded) {
        return <>{children}</>;
    }

    const isFeatureAvailable = stores.ui.app.featureManager.isAvailable(name, strict);

    if (!isFeatureAvailable) {
        return <Navigate to={RouterPaths.MyOrganizationPages.PracticeConnections} replace />;
    }

    if (isFeatureAvailable) {
        return <>{children}</>;
    }

    if (!fallback) {
        return null;
    }
    return isValidElement(fallback) ? cloneElement(fallback, rest) : createElement(fallback as any, rest);
});
